<script setup>
import { Info, RefreshCw, Rocket } from "lucide-vue-next"

const REMIND_AFTER_MS = 30 * 60_000

const wb = getCurrentInstance().proxy.$workbox
const show = ref(false)
const updating = ref(false)
let remindTimer = null

wb?.addEventListener("waiting", () => {
  show.value = true
})

wb?.addEventListener("activated", (event) => {
  if (event.isExternal && !navigator.serviceWorker.controller)
    show.value = true
})

useEventListener(window, "vite:preloadError", () => {
  show.value = true
})

function later() {
  show.value = false
  clearTimeout(remindTimer)
  remindTimer = setTimeout(() => {
    show.value = true
  }, REMIND_AFTER_MS)
}

async function updateNow() {
  updating.value = true
  const registration = await navigator.serviceWorker?.getRegistration()
  if (registration?.waiting && navigator.serviceWorker.controller)
    wb.messageSkipWaiting()
  else window.location.reload()
}

onBeforeUnmount(() => clearTimeout(remindTimer))
</script>

<template>
  <b-modal
    v-model="show"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    body-class="update-modal p-2"
  >
    <button
      type="button"
      class="btn-close update-modal__close"
      aria-label="Close"
      @click="later"
    />

    <div class="text-center">
      <div class="update-modal__icon bg-light-primary text-primary mx-auto mb-1">
        <Rocket :size="28" />
      </div>
      <h4 class="fw-bolder mb-50">
        {{ $t("NewVersionAvailable") }}
      </h4>
      <p class="text-muted mb-1">
        {{ $t("NewVersionDescription") }}
      </p>
    </div>

    <div class="bg-light-warning rounded d-flex align-items-center gap-50 px-1 py-50 mb-2">
      <Info :size="16" class="flex-shrink-0" />
      <small>{{ $t("NewVersionSaveWarning") }}</small>
    </div>

    <button
      type="button"
      class="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-50"
      :disabled="updating"
      @click="updateNow"
    >
      <RefreshCw :size="16" :class="{ 'update-modal__spin': updating }" />
      {{ $t("UpdateNow") }}
    </button>
  </b-modal>
</template>

<style scoped>
.update-modal__close {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

.update-modal__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
}

.update-modal__spin {
  animation: update-modal-spin 1s linear infinite;
}

@keyframes update-modal-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
